import Nullstack from 'nullstack';
export default function IconApiAppOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-api-app-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}